import { useCallback, useState } from 'react';
import { useModal } from 'mui-modal-provider';

import { INotification } from '../../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { OrderCancelModal } from './order-cancel-modal';

export const useOrderCancelledModal = () => {
  const [shouldModalUpdate, setModalUpdateState] = useState(true);
  const { showModal } = useModal();

  const handleOrderCancelModal = useCallback(
    (notifications: INotification[]) => {
      if (!shouldModalUpdate) return;

      const cancelNotification = notifications.find(
        (notification) => notification.notificationType === 'ORDER_CANCEL_BY_STORE',
      );

      if (cancelNotification) {
        showModal(OrderCancelModal, {
          notificationId: cancelNotification.id,
        });
        setModalUpdateState(false);
      }
    },
    [shouldModalUpdate, showModal],
  );

  return {
    handleOrderCancelModal,
  };
};
